// src/components/FormInput.js
import React from "react";
import { FormControl, FormLabel, Input, Select, Textarea, Checkbox, Radio, RadioGroup, Stack } from "@chakra-ui/react";

const FormInput = ({
  label,
  type,
  value,
  onChange,
  options,
  placeholder,
  name,
  direction = "vertical",
  fontSize, // แยก fontSize ออกมา
  ...rest // รับพร็อพที่เหลือทั้งหมด (เช่น size, colorScheme)
}) => {
  return (
    <FormControl>
      {/* ส่ง fontSize ไปยัง FormLabel โดยตรง */}
      <FormLabel fontSize={fontSize}>{label}</FormLabel>
      {type === "select" ? (
        <Select value={value} onChange={onChange} placeholder={placeholder} {...rest}>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      ) : type === "textarea" ? (
        <Textarea value={value} onChange={onChange} placeholder={placeholder} {...rest} />
      ) : type === "file" ? (
        <Input type={type} onChange={onChange} placeholder={placeholder} {...rest} />
      ) : type === "checkbox" ? (
        <Stack direction={direction}>
          {options.map((option, index) => (
            <Checkbox
              key={index}
              isChecked={value.includes(option.value)}
              onChange={(e) => onChange(e, option.value)}
              value={option.value}
              // ถ้าต้องการให้ Checkbox label มี fontSize เดียวกับ FormLabel ก็ส่ง fontSize ไปที่นี่ด้วย
              fontSize={fontSize}
              {...rest}
            >
              {option.label}
            </Checkbox>
          ))}
        </Stack>
      ) : type === "radio" ? (
        <RadioGroup value={value} onChange={onChange}>
          <Stack direction={direction}>
            {options.map((option, index) => (
              <Radio
                key={index}
                value={option.value}
                // ถ้าต้องการให้ Radio label มี fontSize เดียวกับ FormLabel ก็ส่ง fontSize ไปที่นี่ด้วย
                fontSize={fontSize}
                {...rest}
              >
                {option.label}
              </Radio>
            ))}
          </Stack>
        </RadioGroup>
      ) : (
        <Input type={type} value={value} onChange={onChange} placeholder={placeholder} {...rest} />
      )}
    </FormControl>
  );
};

export default FormInput;